import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import { getVehicleDisplayInfo } from '@/features/vehiclesearch';
import type { Vehicle } from '@/features/vehiclesearch/types/vinvrmsearch.types';
import type { VehicleDerivative } from '@/features/vehiclesearch/types/manualsearch.types';
import { SummaryDetailList } from './SummaryDetailList';

interface Props {
    vehicle: Vehicle | VehicleDerivative;
}

export function QuoteVehiclePanel({ vehicle }: Props) {
    const headingId = useId();
    const info = getVehicleDisplayInfo(vehicle);

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>Vehicle</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <SummaryDetailList
                        emptyMessage="No vehicle details are recorded."
                        fields={[
                            { label: 'Make / model', value: `${info.make} ${info.model}` },
                            { label: 'Derivative', value: info.variant },
                            { label: 'VRM', value: info.registration },
                            { label: 'VIN', value: info.vin },
                            { label: 'Year', value: String(info.year) },
                        ]}
                    />
                </section>
            </CardContent>
        </Card>
    );
}
